import script from "./ow-view-rep-daily-programme.vue?vue&type=script&setup=true&lang=js"
export * from "./ow-view-rep-daily-programme.vue?vue&type=script&setup=true&lang=js"

import "./ow-view-rep-daily-programme.vue?vue&type=style&index=0&id=07bd0296&lang=scss"

const __exports__ = script;

export default __exports__